import { organisationConstants } from '../../_constants/organisation.constants';
import swal from 'sweetalert2/dist/sweetalert2.min.js';

const initialState = {
	orgAddLoading: true,
	orgAddError: false,
	orgAddText: ''
};




export function addOrganisation(state = initialState, action) {
	switch (action.type) {
		case organisationConstants.REQUEST_ADD_ORG:
			return {
				orgAddLoading: true,
				orgAddError: false,
				orgAddText: '',
			};
		case organisationConstants.RESPONSE_ADD_ORG:
			return {
				orgAddLoading: false,
				orgAddError: false,
				orgAddText: 'Added Successfully',
			};
		case organisationConstants.REQUEST_ERROR_ORG:
		swal({
            text: action.error.response.data.message.organisation_code[0],
            type: 'error',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'OK'
		  })
			return {
				orgAddLoading: false,
				orgAddError: true,
				orgAddText: 'Something went wrong',
			};
		default:
			return state
	}
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/addOrganisation.reducer.js